!(function () {
  'use strict';
  var e = {};
  e.g = (function () {
    if ('object' == typeof globalThis) return globalThis;
    try {
      return this || new Function('return this')();
    } catch (e) {
      if ('object' == typeof window) return window;
    }
  })();
  const t =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    { fetch: s } = e.g;

  // Helper function to update the DOM elements to the success states
  function applySuccessUI(section, form, above500, isInitialLoad) {
    const r = form.querySelector('input[name="email"]');
    const button = form.querySelector('.submit-btn');
    const initialText = section?.querySelector('.initial-text');
    const initialSuccess = section?.querySelector('.initial-success');
    const over500Success = section?.querySelector('.over-500-success');
    const under500Count = section?.querySelector('.under-500-count');
    const over500Count = section?.querySelector('.over-500-count');
    const currentCountEl = section?.querySelector('#current_count');

    if (button) {
      button.classList.add('claimed');
      button.textContent = 'Claimed';
      button.disabled = true;
    }

    if (initialText) {
      initialText.style.display = 'none';
    }

    if (r) {
      r.placeholder = '';
      r.readOnly = true;
    }

    // Retrieve and parse object values safely from storage using strict Number casting
    const rawMetrics = localStorage.getItem('neon_counter_metrics');
    let metrics = rawMetrics ? JSON.parse(rawMetrics) : { currentValue: 0, userValue: 0 };

    let savedUserValue = Number(metrics.userValue) || 0;
    let savedServerValue = Number(metrics.currentValue) || 0;

    // Determine if this specific user historically registered when count was under 500
    const historicalUnder500User = savedUserValue > 0 && savedUserValue <= 500;

    // Evaluate layout state requirements against user registration history vs live dashboard flag
    if (historicalUnder500User) {
      // Returning user who safely secured a spot under 500 -> Lock their discount text forever
      if (r) r.value = "You're in. Your $100 off is locked.";
      if (initialSuccess) initialSuccess.style.display = 'block';
      if (over500Success) over500Success.style.display = 'none';

      // Override count block presentation if global switch is toggled above-500 to true
      if (above500) {
        if (under500Count) under500Count.style.display = 'none';
        if (over500Count) over500Count.style.display = 'block';
      } else {
        if (under500Count) under500Count.style.display = 'block';
        if (over500Count) over500Count.style.display = 'none';
      }
    } else if (above500) {
      // First-time signup above 500 OR a returning user who signed up above 500
      if (r) r.value = "You're in. You're early.";
      if (under500Count) under500Count.style.display = 'none';
      if (over500Count) over500Count.style.display = 'block';
      if (initialSuccess) initialSuccess.style.display = 'none';
      if (over500Success) over500Success.style.display = 'block';
    } else {
      // Standard under 500 live form submission track
      if (r) r.value = "You're in. Your $100 off is locked.";
      if (under500Count) under500Count.style.display = 'block';
      if (over500Count) over500Count.style.display = 'none';
      if (initialSuccess) initialSuccess.style.display = 'block';
      if (over500Success) over500Success.style.display = 'none';
    }

    if (currentCountEl) {
      const currentServerValue =
        Number(currentCountEl.getAttribute('data-server-raw') || currentCountEl.textContent) || 0;

      if (!isInitialLoad) {
        // PATH: Live first-time signup
        const newUserValue = currentServerValue + 1;
        currentCountEl.textContent = newUserValue;

        localStorage.setItem(
          'neon_counter_metrics',
          JSON.stringify({
            currentValue: currentServerValue,
            userValue: newUserValue,
          }),
        );
      } else {
        if (currentServerValue > savedServerValue) {
          currentCountEl.textContent = currentServerValue;

          localStorage.setItem(
            'neon_counter_metrics',
            JSON.stringify({
              currentValue: currentServerValue,
              userValue: currentServerValue,
            }),
          );
        } else {
          currentCountEl.textContent = savedUserValue;

          localStorage.setItem(
            'neon_counter_metrics',
            JSON.stringify({
              currentValue: currentServerValue,
              userValue: savedUserValue,
            }),
          );
        }
      }
    }
  }

  class r extends HTMLElement {
    constructor() {
      super();
      this.listId = KLAVIYO_LIST_ID;
      this.form = this.querySelector('.newsletter-form');
      this.forms = [...this.querySelectorAll('form')];
      this.forms.forEach((e) => {
        e.addEventListener('submit', this.onSubmit);
      });
    }
    destroy = () => {
      this.form.removeEventListener('submit', this.onSubmit);
    };
    onSubmit = (e) => {
      e.preventDefault();
      let r = e.target.querySelector('input[name="email"]'),
        o = (e.target.querySelector('.newsletter-form-success'), e.target.querySelector('.error'));
      (o.querySelector('span'),
        e.preventDefault(),
        t.test(r.value)
          ? (function (e, t) {
              let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 'Both';
              const i = Object.assign({}, r, { g: e, email: t, $fields: 'Interests', Interests: o }),
                a = Object.keys(i).reduce((e, t) => (e.append(t, i[t]), e), new URLSearchParams());
              return s('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
                method: 'POST',
                headers: {
                  'Access-Control-Allow-Headers': '*',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                body: a,
              }).then((e) => e.json());
            })(this.listId, r.value)
              .then((response) => {
                if (response.success) {
                  o.classList.remove('active');

                  const form = e.target;

                  if ((window.location.pathname.toLowerCase() === '/pages/neon' || document.body.classList.contains('template-product-neon'))) {
                    const section = form.closest('#neon-launch');
                    const above500 = section?.getAttribute('data-above-500') === 'true';

                    applySuccessUI(section, form, above500, false);
                  } else {
                    r.value = "Thanks! You're signed up.";
                    r.placeholder = '';
                  }
                } else {
                  o.classList.add('active');
                  setTimeout(() => {
                    o.classList.remove('active');
                    r.value = '';
                  }, 3000);
                }
              })
              .catch((e) => {
                (console.log(e),
                  r.classList.add('active'),
                  (r.value = ''),
                  setTimeout(() => {
                    (o.classList.remove('active'), (r.value = ''));
                  }, 3e3),
                  alert('An error occured. Please try again later.'));
              })
          : o.classList.add('active'));
    };
  }
  customElements.define('klaviyo-form', r);

  document.addEventListener('DOMContentLoaded', function () {
    const neonSection = document.getElementById('neon-launch');
    if (neonSection && (window.location.pathname.toLowerCase() === '/pages/neon' || document.body.classList.contains('template-product-neon'))) {
      const above500 = neonSection.getAttribute('data-above-500') === 'true';
      const under500Count = neonSection.querySelector('.under-500-count');
      const over500Count = neonSection.querySelector('.over-500-count');
      const currentCountEl = neonSection.querySelector('#current_count');
      const klaviyoFormEl = neonSection.querySelector('klaviyo-form');
      const standardForm = klaviyoFormEl?.querySelector('.newsletter-form');

      // Lock down the original pristine server string as an immutable data attribute using numbers
      if (currentCountEl) {
        const rawServerText = String(currentCountEl.textContent).trim();
        currentCountEl.setAttribute('data-server-raw', rawServerText);
      }

      // If the tracking object exists, handle the layout state transformations right here
      if (localStorage.getItem('neon_counter_metrics') !== null) {
        if (neonSection && klaviyoFormEl && standardForm) {
          applySuccessUI(neonSection, standardForm, above500, true);
        }
      } else {
        // Fallback layout mapping rules for new unregistered users
        const initialText = neonSection.querySelector('.initial-text');
        const initialSuccess = neonSection.querySelector('.initial-success');
        const over500Success = neonSection.querySelector('.over-500-success');

        if (above500) {
          if (under500Count) under500Count.style.display = 'none';
          if (over500Count) over500Count.style.display = 'block';

          if (initialText) initialText.style.display = 'none';
          if (initialSuccess) initialSuccess.style.display = 'none';
          if (over500Success) over500Success.style.display = 'block';
        } else {
          if (under500Count) under500Count.style.display = 'block';
          if (over500Count) over500Count.style.display = 'none';

          if (over500Success) over500Success.style.display = 'none';
          if (initialSuccess) initialSuccess.style.display = 'none';
          if (initialText) initialText.style.display = 'block';
        }
      }
    }
  });
})();
